import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { dataMapper } from "@/services/store/modules/data/store";
import { uiMapper } from "@/services/store/modules/ui/store";
import IconSvg from "@/components/IconSvg.vue";
import ButtonApp from "@/components/ButtonApp.vue";
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState([
            "address",
            "addressLink",
            "phone",
            "formCall",
            "whatsapp",
        ]),
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "deactivateFormField",
            "clearForm",
        ]),
    },
});
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
    methods: {
        ...uiMapper.mapMutations(["closeFormCall", "openFormCall"]),
    },
});
let FooterApp = class FooterApp extends Mixins(DataMappers, UiMappers) {
    get isLtMd() {
        return this.breakpoint === "xs" || this.breakpoint === "sm";
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Перезвоните мне");
        this.setFormCallScreen("Модальное окно 'Перезвоните мне' Футер");
        this.deactivateFormField(this.formCallMail);
        this.openFormCall();
    }
};
FooterApp = __decorate([
    Component({
        components: {
            IconSvg,
            ButtonApp,
        },
        filters: {
            phoneDisplay: (value) => {
                if (!value)
                    return;
                const res = "+7 (" +
                    value.slice(2, 5) +
                    ") " +
                    value.slice(5, 8) +
                    "-" +
                    value.slice(-4);
                return res;
            },
        },
    })
], FooterApp);
export default FooterApp;
